import { render, staticRenderFns } from "./relatorioFinaceiroIOF.vue?vue&type=template&id=0ad2b78c"
import script from "./relatorioFinaceiroIOF.vue?vue&type=script&lang=js"
export * from "./relatorioFinaceiroIOF.vue?vue&type=script&lang=js"
import style0 from "./relatorioFinaceiroIOF.vue?vue&type=style&index=0&id=0ad2b78c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports